<template>
  <div
    v-if="showNav"
    class="
      nav-overlay
      tw-absolute
      tw-top-0
      tw-bottom-0
      tw-bg-black
      tw-bg-opacity-60
      tw-left-0
      tw-right-0
      tw-z-10
      md:tw-hidden
    "
  ></div>
  <div
    class="
      tw-container tw-mx-auto tw-flex tw-flex-col-reverse
      md:tw-flex-row
      tw-relative tw-px-2
    "
  >
    <div
      class="md:tw-w-4/12 lg:tw-w-3/12 tw-bg-white md:tw-relative md:tw-pr-3"
      :class="
        showNavigation
          ? 'tw-fixed tw-py-5 tw-top-6 tw-z-10 tw-left-0 tw-right-0 tw-px-4 tw-bottom-0 tw-overflow-y-scroll md:tw-overflow-hidden tw-border-white tw-border-1 md:tw-border-0 tw-rounded-tr-3xl tw-rounded-tl-3xl'
          : 'tw-hidden'
      "
    >
      <div
        class="
          tw-flex tw-items-center tw-font-bold
          md:tw-font-regular
          tw-text-xl tw--mx-4
          md:tw-mx-0
          tw-pb-3 tw-mb-3 tw-items-between tw-border-b-1
          md:tw-border-0
          tw-border-gray-200 tw-border-solid tw-justify-center
          md:tw-justify-start
        "
      >
        {{ Translation.FilterSection.FilterHeadline }}
        <span class="tw-hidden md:tw-block">:</span
        ><XIcon
          @click="toggleNav"
          class="
            tw-w-5 tw-h-5 tw-absolute tw-top-5 tw-right-5 tw-justify-self-end
            md:tw-hidden
          "
        />
      </div>
      <loading-overlay
        color="noraBlue-500"
        class="tw-text-3xl"
        v-if="loading"
      />
      <template v-for="(block, index) in activeFilter" :key="index">
        <div v-if="block.Group === 'ColorGroupName'">
          <h4 class="tw-mb-3">{{ Translation.FilterSection.Category1 }}</h4>
        </div>
        <div v-if="block.Group === 'SoundInsulation'">
          <h4 class="tw-mt-6 tw-mb-3">
            {{ Translation.FilterSection.Category2 }}
          </h4>
        </div>
        <div v-if="block.Group === 'Format'">
          <h4 class="tw-mt-6 tw-mb-3">
            {{ Translation.FilterSection.Category3 }}
          </h4>
        </div>
        <div v-if="block.Group === 'ProductCollectionType'">
          <h4 class="tw-mt-6 tw-mb-3">
            {{ Translation.FilterSection.ProductLine }}
          </h4>
        </div>
        <FilterGroup
          :group="block"
          @filterChange="collectionFilterChecked"
          v-if="block.Group === 'ProductCollectionType'"
          :alwaysOpen="true"
        />
        <FilterGroup :group="block" @filterChange="filterChecked" v-else />
      </template>
    </div>
    <div class="md:tw-w-8/12 lg:tw-w-9/12 tw-relative tw-overflow-hidden">
      <div class="tw-flex tw-border-b-4 tw-mb-8">
        <Tab
          :label="`Products (${TotalProductCount})`"
          :active="currentState === State.PRODUCTS"
          @click="activateTab(State.PRODUCTS)"
        />
        <Tab
          :label="`Collections (${visibleCollectionCount})`"
          :active="currentState === State.COLLECTIONS"
          @click="activateTab(State.COLLECTIONS)"
        />
      </div>
      <loading-overlay
        color="noraBlue-500"
        class="tw-text-3xl"
        v-if="loading"
      />
      <template v-if="currentState === State.PRODUCTS">
        <div
          v-if="TotalProductCount > 0"
          class="tw-my-3 tw-bg-noraGray-100 tw-px-3 tw-py-2"
        >
          {{ TotalProductCount }} {{ Translation.ActiveFilterbar.TotalResults }}
        </div>
        <div class="filterBar">
          <ErrorMessage
            class="tw-mt-2 tw-mb-2"
            v-if="error"
            :lightBg="true"
            :arrowTop="false"
            :arrowBottom="false"
            :message="error"
            :headline="errorHeadline"
          />
          <div
            v-if="checkedFilters.length > 0"
            class="tw-my-3 tw-bg-noraGray-100 tw-px-3 tw-py-2"
          >
            <p class="tw-mb-2">{{ Translation.ActiveFilterbar.Headline }}</p>
            <div class="tw-flex tw-flex-wrap">
              <span
                class="
                  tw-px-3
                  tw-py-1
                  tw-mr-3
                  tw-mb-3
                  tw-rounded
                  tw-bg-noraGray-200
                  tw-inline-flex
                  tw-cursor-pointer
                "
                v-for="(filter, index) in checkedFilters"
                :key="index"
              >
                <span class="tw-flex tw-items-center">
                  <span class="tw-mr-3">{{ filter.Text }}</span>
                  <XIcon
                    class="tw-h-5 tw-w-5"
                    aria-hidden="true"
                    @click="removeFilter(filter)"
                  />
                </span>
              </span>
            </div>
            <span
              class="
                tw-self-end tw-underline tw-cursor-pointer
                hover:tw-no-underline
                tw-flex tw-items-center
              "
              @click="removeAllFilters"
              ><XIcon class="tw-mr-1 tw-h-5 tw-w-5" aria-hidden="true" />{{
                Translation.ActiveFilterbar.Clear
              }}
            </span>
          </div>
        </div>
      </template>
      <a
        @click="toggleNav"
        class="
          tw-bg-noraBlue-400
          hover:tw-bg-noraBlue-500
          tw-text-white
          tw-font-bold
          tw-py-2
          tw-px-2
          tw-rounded
          tw-inline-block
          tw-text-center
          tw-w-40
          tw-mb-3
        "
        v-if="showNavToggle"
      >
        <span class="tw-flex tw-items-center tw-justify-center">
          <AdjustmentsIcon class="tw-w-5 tw-mr-5" />
          {{ Translation.FilterSection.FilterMobileButtonText }}
        </span>
      </a>
      <div
        class="sm:tw-grid sm:tw-grid-cols-2 xl:tw-grid-cols-4 sm:tw-gap-5"
        :class="showNav ? 'tw-fixed tw-right-2 tw-left-2 md:tw-relative' : ''"
      >
        <ProductItem
          v-for="(block, index) in results"
          :key="index"
          :item="block"
          :index="index"
          :state="currentState"
          :openIndex="openDetailsIndex"
          :ProductDetailTexts="Translation.ProductDetail"
          :filters="Filter"
          @toggle-details="toggleDetails($event)"
        ></ProductItem>
        <Pagination
          :CurrentPage="Page"
          :TotalPages="TotalPage"
          :TotalProducts="TotalProductCount"
          class="tw-mt-10 tw-col-span-full"
          v-if="TotalPage > 1 && currentState === State.PRODUCTS"
          @pageChange="pageChanged"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FilterGroup from "./components/Filters/FilterGroup";
import ProductItem from "./components/Products/ProductItem";
import { getProductList } from "./services/productlist-service";
import ErrorMessage from "./components/ErrorMessage";
import Pagination from "./components/Pagination";
import LoadingOverlay from "./components/LoadingOverlay";
import Tab from "./components/Tab";

import { XIcon, AdjustmentsIcon } from "@heroicons/vue/solid";

const State = {
  PRODUCTS: "products",
  COLLECTIONS: "collections",
};

export default {
  name: "App",
  inject: ["mq"],
  computed: {
    showNavToggle() {
      return this.mq.mdMinus && this.currentState === this.State.PRODUCTS
        ? true
        : false;
    },
    showNavigation() {
      if (this.mq.lgPlus) {
        return true;
      } else if (this.mq.lgMinus && this.showNav) return true;
      else {
        return false;
      }
    },
    showDesktopNav() {
      return !this.mq.lgPlus ? true : false;
    },
    filteredCollectionResults() {
      if (this.checkedCollectionFilter) {
        return this.CollectionResults.filter(
          ({ ProductCollectionType }) =>
            ProductCollectionType === this.checkedCollectionFilter.Value
        );
      } else {
        return this.CollectionResults;
      }
    },
    results() {
      if (this.currentState === State.PRODUCTS) {
        return this.ProductResults;
      } else {
        return this.filteredCollectionResults;
      }
    },
    visibleCollectionCount() {
      if (this.checkedCollectionFilter) {
        return this.filteredCollectionResults.length;
      } else {
        return this.TotalCollectionCount;
      }
    },
    activeFilter() {
      if (this.currentState === State.PRODUCTS) {
        return this.Filter;
      } else {
        return this.CollectionFilter;
      }
    },
  },
  emits: ["filterChange", "pageChange"],
  components: {
    FilterGroup,
    ProductItem,
    ErrorMessage,
    Pagination,
    LoadingOverlay,
    XIcon,
    AdjustmentsIcon,
    Tab,
  },
  data() {
    return {
      currentState: State.PRODUCTS,
      State,
      checkedCollectionFilter: null,
    };
  },
  created() {
    this.updateCheckedFilters();
    this.getProductList();
  },
  methods: {
    toggleNav() {
      this.showNav = !this.showNav;
      const body = document.getElementsByTagName("body")[0];
      body.classList.toggle("overflow-hidden");
    },
    toggleDetails(itemIndex) {
      let index = itemIndex.toString();
      if (this.openDetailsIndex === index) {
        this.openDetailsIndex = null;
      } else {
        this.openDetailsIndex = index;
      }
    },
    async getProductList(page = 1) {
      const requestData = {
        Id: this.Id,
        SettingsId: this.SettingsId,
        SearchSettingsId: this.SearchSettingsId,
        Page: page,
        Filter: this.Filter,
      };

      this.loading = true;

      try {
        this.setError();
        const result = await getProductList(requestData);
        if (result.success) {
          this.ProductResults = result.data.ProductResults;
          this.TotalProductCount = result.data.TotalProductCount;
          this.CollectionResults = result.data.CollectionResults;
          this.TotalCollectionCount = result.data.TotalCollectionCount;
          this.Page = result.data.Page;
          this.TotalPage = result.data.TotalPage;
          this.Filter = result.data.Filter;
        } else {
          this.setError(result.status.message);
        }
      } catch (e) {
        this.setError("HTTP Error");
        console.error(e);
      }
      this.loading = false;
    },

    pageChanged(page) {
      this.loading = true;
      this.openDetailsIndex = null;
      this.getProductList(page);
    },

    filterChecked(filterObject) {
      this.loading = true;

      // change filter selected state after checking group
      const result = this.findFilter(filterObject);

      if (result.Type === "Radio") {
        result.Items.forEach((item) => (item.Selected = false));
      }

      result.Items[filterObject.index].Selected =
        !result.Items[filterObject.index].Selected;

      this.updateCheckedFilters();
      this.getProductList();
    },
    collectionFilterChecked(filterObject) {
      // change filter selected state after checking group
      const result = this.CollectionFilter.find(
        ({ Group }) => Group === filterObject.Group
      );

      if (result.Type === "Radio") {
        result.Items.forEach((item) => (item.Selected = false));
      }

      result.Items[filterObject.index].Selected =
        !result.Items[filterObject.index].Selected;

      if (!filterObject.Item.Value) {
        this.checkedCollectionFilter = null;
      } else {
        this.checkedCollectionFilter = filterObject.Item;
      }
    },
    updateCheckedFilters() {
      let checkedFilters = [];

      this.Filter.forEach((filter) => {
        filter.Items.forEach((item) => {
          if (item.Selected && item.Value) {
            checkedFilters.push(item);
          }
        });
      });
      this.checkedFilters = checkedFilters;
    },
    removeFilter(f) {
      this.Filter.forEach((filterGroup) => {
        filterGroup.Items.forEach((filterItem) => {
          if (filterItem.Text === f.Text) {
            filterItem.Selected = false;
            if (filterGroup.Type === "Radio")
              filterGroup.Items[0].Selected = true;
          }
        });
      });
      this.updateCheckedFilters();
      this.getProductList();
    },
    removeAllFilters() {
      this.Filter.forEach((filterGroup) => {
        filterGroup.Items.forEach((filterItem) => {
          filterItem.Value === null
            ? (filterItem.Selected = true)
            : (filterItem.Selected = false);
        });
      });
      this.updateCheckedFilters();
      this.getProductList();
    },
    findFilter(filterObject) {
      return this.Filter.find(
        (filterGroup) => filterGroup.Group === filterObject.Group
      );
    },
    setError(message = null, headline = null) {
      this.error = message;
      this.errorHeadline = headline;
    },
    activateTab(state) {
      this.currentState = state;
    },
  },
};
</script>

<style></style>
